import { Sparkles } from "lucide-react";
import { useLang } from "../store/lang";

const LINKS = [
  { id: "nav-chapters-link", label: "Her Name", href: "#chapters" },
  { id: "nav-aqiqah-link", label: "Aqiqah", href: "#aqiqah" },
  { id: "nav-games-link", label: "Games", href: "#games" },
  { id: "nav-wishes-link", label: "Wishes", href: "#wishes" },
  { id: "nav-venue-link", label: "Venue", href: "#invitation" },
  { id: "nav-journey-link", label: "Fairytale", href: "/journey", hideXs: true },
];

export const Navbar = () => {
  const { ur, toggle } = useLang();
  const go = (e, href) => {
    e.preventDefault();
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(href, { offset: -70, duration: 1.6 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-nav"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-[#05060F]/92 border-b border-amber-300/40 shadow-[0_1px_0_rgba(243,229,171,0.35),0_10px_40px_-10px_rgba(212,175,55,0.45)]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-5 h-16 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => go(e, "#hero")}
          className="flex items-center gap-2 text-amber-200 drop-shadow-[0_0_10px_rgba(243,229,171,0.55)]"
          data-testid="nav-brand"
        >
          <Sparkles size={20} className="text-amber-300" />
          <span className="hidden sm:inline font-royal tracking-[0.3em] text-sm whitespace-nowrap gold-text">H · N · J</span>
        </a>
        <div className="flex items-center gap-1 sm:gap-5 flex-nowrap">
          {LINKS.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              onClick={(e) => {
                if (!l.href.startsWith("/")) go(e, l.href);
              }}
              className={`text-[0.6rem] min-[420px]:text-[0.68rem] sm:text-[0.8rem] font-semibold tracking-[0.08em] sm:tracking-[0.2em] uppercase text-amber-50 hover:text-amber-300 transition-colors duration-300 px-1 sm:px-2 py-1 whitespace-nowrap [text-shadow:0_0_12px_rgba(243,229,171,0.35)] ${l.hideXs ? "hidden min-[480px]:block" : ""}`}
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            aria-label="Toggle Urdu language"
            className="ml-2 shrink-0 text-[0.75rem] font-semibold px-3.5 py-1.5 rounded-full bg-gradient-to-r from-[#f3e5ab] to-[#d4af37] text-[#1b1407] shadow-[0_0_18px_rgba(212,175,55,0.55)] hover:shadow-[0_0_26px_rgba(212,175,55,0.8)] transition-shadow duration-300"
          >
            {ur ? "EN" : "اردو"}
          </button>
        </div>
      </div>
    </nav>
  );
};
